import { cn } from '../../utils/cn';

const markUrl = '/brand/spitertech-mark.png';

type LogoTheme = 'dark' | 'light';

type LogoMarkProps = {
  className?: string;
  alt?: string;
};

/** Spitertech brand emblem (the circular "S" mark from the company logo). */
export function LogoMark({ className, alt = 'Spitertech Solutions' }: LogoMarkProps) {
  return <img alt={alt} className={cn('h-11 w-11 shrink-0', className)} src={markUrl} width={44} height={44} />;
}

type LogoProps = {
  theme?: LogoTheme;
  /** Hide the wordmark and render the emblem only. */
  markOnly?: boolean;
  className?: string;
};

export function Logo({ theme = 'dark', markOnly = false, className }: LogoProps) {
  const onLight = theme === 'dark';

  return (
    <span className={cn('flex items-center gap-3', className)}>
      <LogoMark alt={markOnly ? 'Spitertech Solutions' : ''} />
      {markOnly ? null : (
        <span className="leading-none">
          <span className={cn('block text-lg font-bold tracking-tight', onLight ? 'text-brand-900' : 'text-white')}>
            Spiter<span className="text-brand-500">tech</span>
          </span>
          <span
            className={cn(
              'mt-1 block text-[0.68rem] font-semibold uppercase tracking-[0.26em]',
              onLight ? 'text-muted' : 'text-brand-100',
            )}
          >
            Solutions LLP
          </span>
        </span>
      )}
    </span>
  );
}
